// Tealium tagging related
export const TEALIUM_SITE = "mm-orbit";
export const TEALIUM_PAGE_CATEGORY = "1";
export const SUCCESS = "SUCCESS";
export const CONTENT_TYPE = "candidate";
export const TEALIUM_USER_ROLE = "candidate";
